import React from "react";
import styles from "./style.module.css";
import Navbar from "../../../components/atoms/Navbar";
import logo from "../../../assets/images/blitz_logo.svg";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar noLogo={false} logo={logo} />
      <div className={styles.privacyPolicyContainer}>
        <h1 className={styles.title}>PRIVACY POLICY</h1>

        <p className={styles.paragraph}>
          In this Privacy Policy "we", "our" and "us" refers to the Company and
          "you" and/or "your" refers to the user(s) of the Website ("User(s)"),
          which includes Merchants, clients, and service recipients of the
          Company (natural or legal person) registered with the Website and all
          of their employees and authorised users (“Merchant”).
        </p>
        <p className={styles.paragraph}>
          The Company provides various services to the Merchants and Users
          ("Services") through the Website. The use of the Website for the
          Services provided by the Company to the Merchant are additionally
          governed by the Service Agreement and/or Merchant Agreement as may be
          separately executed between the Merchant and the Company, from time to
          time. Your visit to this Website is subject to this privacy, security
          and cookies policy ("Privacy Policy") and other Terms and Conditions
          of this Website.
        </p>
        <p className={styles.paragraph}>
          The Company respects the importance of the privacy of Merchants that
          register on the Website and of the end customers of the Merchant. This
          Privacy Policy accounts for the personal data and cookies etc., used
          via Website to provide world class logistics solutions to its Merchant
          and its customers. Please read this Privacy Policy carefully to make
          sure you understand how any personal information (including sensitive
          personal data or information) of yours or any of your customers
          provided to us will be treated, stored, and handled by us.
        </p>
        <p className={styles.paragraph}>
          This document is published and shall be construed in accordance with
          the provisions of the Information Technology Act, 2000 read with
          Information Technology (Reasonable Security Practices and Procedures
          and Sensitive Personal Data of Information) Rules, 2011 under the
          Information Technology Act, 2000, that require publishing of the
          Privacy Policy for collection, use, storage and transfer of sensitive
          personal data or information.
        </p>
        <p className={styles.paragraph}>
          This Privacy Policy is provided to explain our policies and practices
          regarding the collection, use, storing and disclosure of information
          about you. We observe the highest standards of security to secure
          transactions and user information privacy. Please read the following
          statement to learn about our information gathering, storing and
          dissemination practices.
        </p>
        <p className={styles.paragraph}>
          The Company respects the importance of the privacy of Merchants that
          register on the Website and of the end customers of the Merchant. This
          Privacy Policy accounts for the personal data and cookies etc., used
          via Website to provide world class logistics solutions to its Merchant
          and its customers. By accessing and utilising the Website, you consent
          to the collection, use, disclosure, storage and processing of personal
          data and information in accordance with this Privacy Policy. In the
          course of using this Website or availing the Services offered by the
          Company on the Website, the Company and its affiliates may become
          privy to the personal information of the Users, including information
          that is of a confidential nature.
        </p>

        <h2 className={styles.sectionTitle}>
          What Personal Information Does the Company Gather & Why
        </h2>
        <p className={styles.paragraph}>
          Our primary goal in collecting information and data, including
          personally identifiable information, is to provide you with a smooth,
          efficient, and customized experience. This allows us to provide
          services and features that are most likely to meet your needs, and to
          customize the Website and our Services to make your experience easier.
        </p>

        <h3 className={styles.sectionTitle}>Service-Related Records</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            We collect the details and information provided by the Merchant
            together with information we learn about you from your use of our
            Services and your visits to our Website and other websites
            accessible from them, to provide more effective Services and
            includes all information that can be linked to a specific individual
            or to identify any individual, such as name, address, mailing
            address, telephone number, email ID. When you visit the Website, we
            may collect information regarding the domain and host from which you
            access the internet, the Internet Protocol [IP] address of the
            computer or Internet service provider [ISP] you are using, and
            anonymous site statistical data ("Information").
          </li>
          <li className={styles.listItem}>
            We require accurate Information and data to provide efficient
            Services, and you hereby represent to the company that:
            <ul className={styles.list}>
              <li className={styles.listItem}>
                (a) the information you provide to the Company from time to time
                is and shall be authentic, correct, current and updated and you
                have all the rights, permissions and consents as may be required
                to provide such information to the Company.
              </li>
              <li className={styles.listItem}>
                (b) You are providing the information to the Company's
                consequent storage, collection, usage, transfer, access or
                processing of the same shall not be in violation of any
                third-party agreement, laws, charter documents, judgments,
                orders and decrees.
              </li>
            </ul>
          </li>
        </ul>

        <h3 className={styles.sectionTitle}>Cookies from the Website</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            Web cookies are small pieces of data sent by the Website and they
            are stored by your browser on your computer’s hard drive, thereby
            uniquely identifying your browser. Cookies are used to track and
            record your preferences when you visit the Website.
          </li>
          <li className={styles.listItem}>
            Currently, our Website does not require to send or read the cookies
            from your computer. In the event any functionality of the Website
            requires, the Company reserve the right to use the cookies in
            future. This data is used to improve our offerings, such as
            providing more content in areas of greater interest to a majority of
            Users. Most browsers are initially set up to accept cookies, but you
            can reset your browser to refuse all cookies or to indicate when a
            cookie is being sent. Some of our features and services may not
            function properly if your cookies are disabled.
          </li>
        </ul>

        <h3 className={styles.sectionTitle}>Links</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            Our Website links to other websites that may collect personally
            identifiable information about you. The Company is not responsible
            for the privacy practices or the content of those linked websites.
          </li>
        </ul>

        <h3 className={styles.sectionTitle}>User Communications</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            When you send email or other communication to us, we may retain
            those communications to process your inquiries, respond to your
            requests and improve our services.
          </li>
        </ul>

        <h2 className={styles.sectionTitle}>DISCLOSURE OF INFORMATION</h2>
        <p className={styles.paragraph}>
          Except as provided in this Privacy Policy, we do not sell or rent any
          personally identifiable information or any sensitive personal data and
          information about you or your customers to any third party, other than
          for internal Platform development and maintenance. The following
          describes some of the ways that your information may be disclosed, and
          you hereby agree that the Company may disclose such information
          without requirement for any further consent from you at any point of
          time.
        </p>

        <h3 className={styles.sectionTitle}>Performance of Services:</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            We need to share certain Information with our service partners and
            service provider for performance of Services. To provide efficient
            Services, the Merchant is required to provide certain Information
            (including sensitive personal data or information) relating to the
            customer of the Merchant. The Merchant shall ensure that they have
            adequate consent and authority from its customer to share such the
            Information with the Company. The Company shall not be responsible
            or liable to the customer with respect to the customer Information
            which the Merchant has shared with the Company and the Merchant
            agrees to indemnify and hold the Company and (as applicable) its
            parent, subsidiaries, affiliates, Blitz partners, officers,
            directors, agents, and employees, harmless from any claim or demand,
            including reasonable attorneys’ fees, made by customer or any third
            party due to or arising out of breach of Merchant’s obligations or
            violation of any law or the rights of the customer or any third
            party. We may also use or disclose the Information to resolve
            disputes, troubleshoot concerns, help promote safe services, collect
            money, measure consumer interest in our services, customize your
            experience, detect & protect us against error, fraud, and other
            criminal activity, enforce our terms and conditions, etc.
          </li>
        </ul>

        <h3 className={styles.sectionTitle}>Other Group Entities:</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            We may sometimes share data with our affiliates, and group companies
            and other third-party service providers that provide us with
            services and/or provide you with Services. To the extent that these
            entities have access to your personally identifiable information, we
            will ask them to treat it at least as protectively as they treat
            personally identifiable information they obtain from their other
            authorized users.
          </li>
        </ul>

        <h3 className={styles.sectionTitle}>Legal Requests:</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            The Company co-operates with law enforcement inquiries, as well as
            other third parties to enforce laws relating to matters, such as
            intellectual property rights, fraud and other rights. We can (and
            you authorise us to) disclose any personally identifiable
            information about you or your customer or any records related to the
            Services to law enforcement and other government officials as we, in
            our sole discretion, believe reasonably necessary or appropriate, in
            connection with any investigation, and to protect against imminent
            harm to the rights, property or safety of the Company, its Users or
            the public as required or permitted by law.
          </li>
        </ul>

        <h3 className={styles.sectionTitle}>Alerts:</h3>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            The Company may alert the Users by email or phone (through sms/call)
            to inform the Users about new Services offerings or other
            information which the Company feels might be useful for the Users.
          </li>
        </ul>

        <h2 className={styles.sectionTitle}>SECURITY AND DATA PROTECTION</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            The Company has stringent security measures in place to protect the
            loss, misuse, and alteration of the Information under our control.
            Whenever you change or access your account information, we offer the
            use of a secure server. We adhere to strict security guidelines,
            protecting it against unauthorized access.
          </li>
          <li className={styles.listItem}>
            Your Information will primarily be stored in electronic form on our
            servers and servers of third-party service providers, however
            certain data can also be stored in physical form. We may enter into
            agreements with third parties (in or outside of India) to store or
            process your information or data, always in accordance with
            applicable law. Such third party may store and process Your
            information or data in the server located outside of India.
          </li>
          <li className={styles.listItem}>
            For security purposes, the Company usually uses third party service
            providers who are using security techniques including secure
            servers, clouds, firewalls, and encryptions, as well as physical
            safeguard of the locations where the data are stored, and we will on
            commercial reasonable basis require from such third parties to adopt
            all security standards to safeguard your information / data in
            accordance with all applicable laws. We have in place appropriate
            administrative, technical, physical safeguards and security measures
            to protect the personal data you provide on this Website against
            accidental, unauthorized or unlawful loss, destruction, damage,
            alteration, access, disclosure or use and any other unlawful forms
            of processing. When we collect payment card details electronically,
            we use encryption coding.
          </li>
        </ul>

        <h2 className={styles.sectionTitle}>INDEMNIFICATION</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            You agree to defend, indemnify, and hold the Company harmless, on
            demand, from and against and all claims, damages, costs, and
            expenses, including attorney’s fees, arising from or related to your
            use of the Website
          </li>
        </ul>

        <h2 className={styles.sectionTitle}>DISPUTE RESOLUTION</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            In the event of any dispute, difference or claim arising out of this
            Privacy Policy the same shall be settled in accordance with the Laws
            of India through regular judicial process and the courts of New
            Delhi, India shall have exclusive jurisdiction.
          </li>
        </ul>

        <h2 className={styles.sectionTitle}>CONSENT TO THIS POLICY</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            This document supersedes any prior communication on this topic and
            reflects the entire and exclusive Privacy Policy for the Website. If
            you use any of our Services, you will be regarded as having read and
            accepted this Privacy Policy. By mere use of this Website, you
            expressly consent to our collection, use, disclosure, storage and
            processing of your personal data and information in accordance with
            this Privacy Policy.
          </li>
        </ul>

        <p className={styles.paragraph}>
          Note: We keep updating our Privacy Policy regularly. To make sure that
          you are aware of any changes, kindly review the policy periodically.
          This Privacy Policy shall apply uniformly to all of the Website.
        </p>

        <h2 className={styles.sectionTitle}>GRIEVANCE OFFICER CONTACT</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            In accordance with Information Technology Act 2000 and rules made
            there under, the name and contact details of the Grievance Officer
            are provided below:
          </li>
        </ul>
        <p className={styles.paragraph}>The Grievance Officer</p>
        <p className={styles.paragraph}>Bigshort Tails Private Limited</p>
        <p className={styles.paragraph}>
          Address: 1075-I, 5th Cross Rd, North Appareddipalya, Indiranagar,
          Bengaluru - 560008
        </p>
        <p className={styles.paragraph}>Email: gaurav@blitznow.in</p>
        <p className={styles.paragraph}>Name: Gaurav Piyush</p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
